// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// import { PreloadAllModules } from "@angular/router";

export const environment = {
  production: false,
  debug: true,
  routerConfig: {
    enableTracing: false,
    useHash: false,
    // preloadingStrategy: PreloadAllModules
  },
  defaultRouterLink: 'dang-nhap',
  insufficientPermissionRouterLink: 'error/insufficient-permission',
  cipherKey: 'vNPT#lims#kV5@20',
  cipherKeyRegistry: 'vNPT#ssim#kV5@20',
  rootUrl_Micro: 'http://api.asxh.org.vn/sldtbxh/',
  rootUrl: 'http://10.82.14.241:8080/sldtbxh/',
  rootUrlReport: 'https://baocao.vnptasxh.vn/jasperserver/',
  provinceDefaultId: '82',
  urlDefault: localStorage.getItem('url'),
  nccDefaultProvinceID: 53,
  rootUrlPublicJobExchanges: localStorage.getItem('domain_san'),

  firebase: {
    apiKey: "AIzaSyAttufQyRKGBRPHrRRxmw8SnUyU5Ug6ZDw",
    authDomain: "ssim-cloud-push-notification.firebaseapp.com",
    projectId: "ssim-cloud-push-notification",
    storageBucket: "ssim-cloud-push-notification.appspot.com",
    messagingSenderId: "331423359936",
    appId: "1:331423359936:web:06335eb3ed16e6b5fe5e25",
    measurementId: "G-Z74B4NNNJ8"
  }
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
